export default __webpack_public_path__ + "static/media/Arrowright.c5111be8.svg";